import React from "react"
import { ReactComponent as TableBaseIcon } from "../../../assets/icons/table-base-icon.svg"
import { ReactComponent as PlayIcon } from "../../../assets/icons/play-icon.svg"
import { ReactComponent as CalcIcon } from "../../../assets/icons/calc-icon.svg"
import {
    CONCESSIONS_PAGE,
    CUSTOMERS_PRICE_LOG_PAGE,
    MARKET_RATES_PAGE, MEMORIA_DE_CALCULO,
    PRICES_PAGE,
    PRICES_TABLE_BONDS_PAGE,
    PRICES_UPDATE_SPREADS,
    RATER_CALCULADORA_PAGE,
    SIMULADOR_SUBORDINACAO_PAGE,
    WALLETS_PAGE, FIXED_INCOME_CALCULATOR_PAGE
} from "../../../../utils/routes"

export const PRECIFICATION = [
    {
        icon: <PlayIcon />,
        name: "Apresentação",
        id: "precification-presentation",
        to: "",
    },
    {
        icon: <TableBaseIcon />,
        name: "Tabela PU-TIR",
        id: "menu_precos_tabela",
        to: PRICES_PAGE,
    },
    {
        icon: <TableBaseIcon />,
        name: "Tabela PU-Bonds",
        id: "menu_precos_tabela_bonds",
        to: PRICES_TABLE_BONDS_PAGE,
    },

    {
        icon: <CalcIcon />,
        name: "Memória de Cálculo",
        id: "menu_precos_memoria_calculo",
        to: MEMORIA_DE_CALCULO,
    },
    {
        icon: <TableBaseIcon />,
        name: "Atualização de Spreads",
        id: "menu_precos_atualizacao_spreads",
        to: PRICES_UPDATE_SPREADS,
    },
    {
        icon: <TableBaseIcon />,
        name: "Preços Log",
        id: "menu_precos_clientes_log",
        to: CUSTOMERS_PRICE_LOG_PAGE,
    },
]

export const RATER = [
    {
        icon: <PlayIcon />,
        name: "Apresentação",
        id: "rater-presentation",
        to: "",
    },
    {
        icon: <CalcIcon />,
        name: "Calculadora de Rating",
        id: "menu_rater_calculadora",
        to: RATER_CALCULADORA_PAGE,
    },
    {
        icon: <TableBaseIcon />,
        name: "Cadastros",
        id: "menu_rater",
        to: "",
    },
]

export const RISK_MANAGER = [
    {
        icon: <PlayIcon />,
        name: "Apresentação",
        id: "risk-manager-presentation",
        to: "",
    },
    {
        icon: <TableBaseIcon />,
        name: "Concessão",
        id: "menu_gr_operacoes",
        to: CONCESSIONS_PAGE,
    },
    {
        icon: <TableBaseIcon />,
        name: "Carteira",
        id: "menu_gr_carteiras",
        to: WALLETS_PAGE,
    },
    {
        icon: <CalcIcon />,
        name: "Simulador de Subordinação",
        id: "menu_gr_simulador_subordinacao",
        to: SIMULADOR_SUBORDINACAO_PAGE,
    },
    {
        icon: <CalcIcon />,
        name: "Simulador de RAROC",
        id: "menu_gr_taxas",
        to: "",
    },
    {
        icon: <TableBaseIcon />,
        name: "Taxas de mercado",
        id: "menu_gr_taxas",
        to: MARKET_RATES_PAGE,
    },
]

export const CALC_FIX_REND = [
    {
        icon: <PlayIcon />,
        name: "Apresentação",
        id: "calc-fix-rend-presentation",
        to: "",
    },
    {
        icon: <CalcIcon />,
        name: "Títulos Privados",
        id: "menu_calculadora_calculadora_renda_fixa",
        to: FIXED_INCOME_CALCULATOR_PAGE
    }
]
